import type {UnmappedUser, User} from "./types";

export const mapUser: User = (datum: UnmappedUser) => {
    if (!datum) return
    return {
        loginName: datum.LoginName,
        username: datum.username,
        locale: datum.locale?.toLowerCase(),
    }
}